import { customAxios } from './customAxios'
export function canApproveEsitoADV(idPratica) {
  const config = {
    params: { idPratica: idPratica },
    headers: {
      Accept: "*/*",
      'AuthToken': JSON.parse(localStorage.getItem('token'))
    },
  }
  return customAxios.get(process.env.REACT_APP_BACKEND_HOST + `/`+process.env.REACT_APP_PATH_NEW_PREFIX+`/canApproveEsitoAdv`, config).then(response => response.data.body)
  }